import { observable } from 'mobx';
import axios from 'axios'
import { apiUrl } from '../../config'

class OrderStore {
  @observable carClass = 2
  @observable orderid = 0
  @observable orderStage = null
  @observable foundedCarInfo = null

  @observable frontdoor = ''
  @observable flat = ''
  @observable comment = ''

  @observable pointsCoords = [ [], [] ]

  @observable findedStreets = [ [], [] ]
  @observable selectedStreet = ['', '']
  @observable streetsId = [false, false]
  @observable isPOI = [false, false]

  @observable selectedHouse = ['', '']
  @observable houses = [false, false]
  @observable findedHouses = [ [], [] ]

  @observable anotherPassengerName = ''
  @observable anotherPassengerPhone = ''

  @observable additionalServices = []


  @observable price = { 2: false, 1: false, 5: false, 4: false}
  @observable distance = false
  @observable routeX = []
  @observable routeY = []
  
  
  @observable error = ''
  @observable timeToEnd = null


  chgFrontdoor = evt => {
    this.frontdoor = evt.target.value
  }

  chgFlat = evt => {
    this.flat = evt.target.value
  }

  chgComment = evt => {
    this.comment = evt.target.value
  } 

  getStreets = (clientPhone, name, i) =>{
    // Обнуляем все данные, если происходит поиск улицы
    this.findedStreets[i] = []
    this.streetsId[i] = false
    this.isPOI[i] = false
    this.houses[i] = false
    this.findedHouses[i] = []

    axios.get(`${apiUrl}indpoi.php?street=${name}&lang=`)
      .then( response => {
        const filteredResult = response.data.map( item => {
          const updItem = {...item}
          delete updItem.house
          delete updItem.value

          return updItem
        })

        this.findedStreets[i] = [...filteredResult]
      })
      .catch( err => {
        this.errorMsg = `Ошибка: ${err}`
      })
  }

  setStreet = (streetsId, isPoi, i, text) => {
    const choosedPoint = this.findedStreets[i].filter( street => streetsId === street.id ? true : false )
    if(choosedPoint.length > 0){
      this.pointsCoords[i] = [choosedPoint[0].geox, choosedPoint[0].geoy ]
    }
    
    this.streetsId[i] = streetsId
    this.isPOI[i] = isPoi
    this.selectedStreet[i] = text
    this.selectedHouse[i] = ''
    this.getRouteAndPrice()
  }

  addDestinationRow = () => {
    this.findedStreets.push([])
    this.streetsId.push(false)
    this.isPOI.push(false)
    this.houses.push(false)
    this.findedHouses.push([])
  }
  
  removeDestinationRow = position => {
    this.findedStreets = this.findedStreets.filter( (item, i) => i !== position ? true : false)
    this.streetsId = this.streetsId.filter( (item, i) => i !== position ? true : false)
    this.isPOI = this.isPOI.filter( (item, i) => i !== position ? true : false)
    this.houses = this.houses.filter( (item, i) => i !== position ? true : false)
    this.findedHouses = this.findedHouses.filter( (item, i) => i !== position ? true : false)
    this.pointsCoords = this.pointsCoords.filter( (item, i) => i !== position ? true : false)
    this.getRouteAndPrice()
  }

  getHouse = (house, iter) =>{
    this.findedHouses[iter] = []
    let houseNumber = house ? house : "*"
    const streetid = this.streetsId[iter]
    
    axios.get(`${apiUrl}ind2.php?streetid=${streetid}&house=${houseNumber}`)
      .then( response => {
        this.findedHouses[iter] = [...response.data]
      })
      .catch( err => {
        this.errorMsg = `Ошибка: ${err}`
      })
  }

  setHouse = (house, i, text) => {
    const choosedPoint = this.findedHouses[i].filter( houseInfo => house === houseInfo.value ? true : false)
    if(choosedPoint.length > 0){
      this.pointsCoords[i] = [choosedPoint[0].geox, choosedPoint[0].geoy]
    }

    this.houses[i] = house
    this.selectedHouse[i] = text
    this.getRouteAndPrice()
  }

  setAnotherPassenger = (name, phone) => {
    this.anotherPassengerName = name
    this.anotherPassengerPhone = phone
  }

  setAdditionServices = values => {
    this.additionalServices = values
  }

  setCarClass = id => {
    this.carClass = id
  }

  getRouteAndPrice = (date = Date.now()) => {
    const arrObjectsJSON = this.streetsId.map( (street, i) => {
      const filteredResult = {
        house: this.houses[i],
        streetid: street,
        frontdoor: null,
      }
      if(this.isPOI[i]){
        filteredResult.poiid = street
      }

      return filteredResult
    })


    const options = {
      streetFromID: this.streetsId[0],
      BuildFrom: this.houses[0],
      arrObjectsJSON: JSON.stringify(arrObjectsJSON.slice(1)),
      additionalservices: JSON.stringify(this.additionalServices),
      date: date / 1000,
    }

    if(this.isPOI[0]){
      options.poiid = this.streetsId[0]
    }

    const params = new URLSearchParams(options);
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }


    axios.post(encodeURI(`${apiUrl}getroute.php?all=true`), params, config)
      .then( response => {
        // с PHP прослойки прилетают некоректные данные, необходимо их исправить и привести к нормальному виду
        const objData = response.data.map( (item, i) => {
          item = JSON.parse(item)
          return item
        })

        if(objData[0].err.length < 1 || objData[1].err.length < 1 || objData[2].err.length < 1 || objData[3].err.length < 1){
          // Исправление закончено, формируем цены
          const prices = objData.map( item => {
            return item.price
          })
          this.price = { 2: prices[0], 1: prices[1], 5: prices[2], 4: prices[3]}
          this.distance = objData[0].distance
          this.routeX = objData[0].routex
          this.routeY = objData[0].routey
        }
        
      })
      .catch( err => {
        console.log(err)
      })

  }

  clearOrderForm = () => {
    this.carClass = 2
    this.pointsCoords = [ [], [] ]

    this.selectedStreet = ['', '']
    this.findedStreets = [ [], [] ]
    this.streetsId = [false, false]
    this.isPOI = [false, false]
  
    this.selectedHouse = ['', '']
    this.houses = [false, false]
    this.findedHouses = [ [], [] ]
  
    this.anotherPassengerName = ''
    this.anotherPassengerPhone = ''
  
    this.additionalServices = []

    this.price = { 2: false, 1: false, 5: false, 4: false}
    this.distance = false
    this.routeX = []
    this.routeY = []
  }

  onChangeStreet = (text, i) => {
    this.selectedStreet[i] = text
    if(text.length < 1){
      this.pointsCoords[i] = []
      this.streetsId[i] = false
      
      this.selectedHouse[i] = ''
      this.houses[i] = false
      this.findedHouses[i] = []

      this.isPOI[i] = false
      this.price = { 2: false, 1: false, 5: false, 4: false}
      this.distance = false
      this.routeX = []
      this.routeY = []
    }
  }

  onChangeHouse = (text, i) => {
    this.selectedHouse[i] = text
    if(text.length < 1){
      this.pointsCoords[i] = []
      this.houses[i] = false
      
      this.isPOI[i] = false
      this.price = { 2: false, 1: false, 5: false, 4: false}
      this.distance = false
      this.routeX = []
      this.routeY = []
    }
  }

  createOrder = () => {
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userInfo = JSON.parse(localStorage.getItem('clienInfo'))

    const to = this.selectedStreet.map( (street, i) => {
      return `${street} ${this.selectedHouse[i]}`
    })

    const toStr = to.slice(1).join('->')
    
    const destinations = this.selectedStreet.slice(1).map( (street, i) => {
      return {
        house: this.selectedHouse[i+1],
        streetid: this.streetsId[i+1],
        frontdoor: null,
      }
    })
    
    const options = {
      frontdoor: this.frontdoor,
      flat: this.flat,
      nameUser: `${userInfo.varFirstName} ${userInfo.varLastName}`,
      phone: userInfo.varTel,
      streetFromID: Number(this.streetsId[0]),
      BuildFrom: this.selectedHouse[0],
      arrObjectsJSON: JSON.stringify(destinations),
      ClassAvto: Number(this.carClass),
      additionalservices: JSON.stringify(this.additionalServices),
      fromStr: `${this.selectedStreet[0]}, ${this.selectedHouse[0]}`,
      toStr: toStr,
      optation: this.comment,
      price: this.price[this.carClass],
      distance: this.distance,
      date: Date.now() / 1000,
      sourceorder: 0,
      orderid: Number(this.orderid),
    }
    
    if(this.anotherPassengerName.length > 0 && this.anotherPassengerPhone.length > 0){
      options.nameUser2 = this.anotherPassengerName
      options.phone2 = this.anotherPassengerPhone
    }

    if(this.isPOI[0]){
      options.poiid = options.streetFromID
    }
    
    const params = new FormData();
    for(let key in options){
      params.append(key, options[key])
    }

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    axios.post(`${apiUrl}create_order.php?PHPSESSID=${PHPSESSID}&func=CreateOrder2`, params, config)
      .then( response => {
        if(response.data.err.length > 0){
          this.error = response.data.err
        } else {
          this.orderid = response.data.orderid
          this.timeToEnd = Math.round(Date.now()/1000) + 47
          this.orderStage = 'search'

          // запускаем поиск машины
          axios.get(`${apiUrl}createorder.php?PHPSESSID=${PHPSESSID}&func=StartAutoSearch&orderid=${this.orderid}&phone=${userInfo.varTel}`)
          .then( response => {
            if(response.data.carbrand && response.data.carcolor && response.data.statenumber && response.data.driverphone && response.data.ordertodatetime){
              this.foundedCarInfo = {
                carbrand: response.data.carbrand,
                carcolor: response.data.carcolor,
                statenumber: response.data.statenumber,
                driverphone: response.data.driverphone,
                ordertodatetime: response.data.ordertodatetime,
                callsign: response.data.autodriverid,
              }
              this.orderStage = 'carfound'
              axios.get(`${apiUrl}createorder.php?PHPSESSID=${PHPSESSID}&func=WebOrderConfirm&orderid=${this.orderid}&phone=${userInfo.varTel}`)
                .then( responseWebOrderConfirm => {
                  console.log('WebOrderConfirm', responseWebOrderConfirm.data)
                })
                .catch( errWebOrderConfirm => {
                  this.timeToEnd = null
                  this.orderid = 0
                  this.orderStage = null
                  console.log(errWebOrderConfirm)
                })
            } else {
              this.foundedCarInfo = null
              this.orderStage = 'notfound'
            }
                 
          })
          .catch( err => {
            this.timeToEnd = null
            this.orderid = 0
            this.orderStage = null
            console.log(err)
          })
        }
        console.log(response.data)        
      })
      .catch( err => {
        console.log(err)
      })
  }

  cancelOrder = () => {
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userInfo = JSON.parse(localStorage.getItem('clienInfo'))

    const message = 'Нажата кнопка отмены'
    axios.get(`${apiUrl}createorder.php?PHPSESSID=${PHPSESSID}&func=CancelOrder&orderid=${this.orderid}&phone=${userInfo.varTel}&message=${message}`)
      .then( response => {
        this.timeToEnd = null
        this.orderid = 0
        this.orderStage = null
        this.foundedCarInfo = null
        console.log(response.data)        
      })
      .catch( err => {
        console.log(err)
      })
  }

  chkOrderStatus = () => {
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userInfo = JSON.parse(localStorage.getItem('clienInfo'))

    axios.get(`${apiUrl}createorder.php?PHPSESSID=${PHPSESSID}&func=GetOrderInfo&orderid=${this.orderid}&phone=${userInfo.varTel}`)
      .then( response => {
        if(response.data.folder == 2 && this.orderStage !== 'cararrived'){
          // проверяем, водитель отметил что ожидает клиента или нет
          axios.get(`${apiUrl}getauto.php?PHPSESSID=${PHPSESSID}&func=GetCoordinatesAuto&callsignid=${this.foundedCarInfo.callsign}&phone=${userInfo.varTel}`)
            .then( carRes => {
              if(carRes.statusforweborder == 1){
                this.orderStage = 'cararrived'
              }
            })
            .catch( carErr => {
              console.log(carErr)
            })
        }

        if(response.data.folder == 3){
          this.orderStage = 'onway'
        }

        if(response.data.folder == 4){
          this.timeToEnd = null
          this.orderid = 0
          this.orderStage = null
          this.foundedCarInfo = null
        }
        console.log(response.data)
      })
      .catch( err => {
        console.log(err)
      })
  }

  restartAutoSearch = () => {
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userInfo = JSON.parse(localStorage.getItem('clienInfo'))
    
    axios.get(`${apiUrl}createorder.php?PHPSESSID=${PHPSESSID}&func=StartAutoSearch&orderid=${this.orderid}&phone=${userInfo.varTel}`)
      .then( response => {
        if(response.data.carbrand && response.data.carcolor && response.data.statenumber && response.data.driverphone && response.data.ordertodatetime){
          this.foundedCarInfo = {
            carbrand: response.data.carbrand,
            carcolor: response.data.carcolor,
            statenumber: response.data.statenumber,
            driverphone: response.data.driverphone,
            ordertodatetime: response.data.ordertodatetime,
          }
          this.orderStage = 'carfound'
          axios.get(`${apiUrl}createorder.php?PHPSESSID=${PHPSESSID}&func=WebOrderConfirm&orderid=${this.orderid}&phone=${userInfo.varTel}`)
            .then( responseWebOrderConfirm => {
              console.log('WebOrderConfirm', responseWebOrderConfirm.data)
            })
            .catch( errWebOrderConfirm => {
              this.timeToEnd = null
              this.orderid = 0
              this.orderStage = null
              console.log(errWebOrderConfirm)
            })

        } else {
          this.foundedCarInfo = null
          this.orderStage = 'notfound'
        }      
      })
      .catch( err => {
        this.timeToEnd = null
        this.orderid = 0
        this.orderStage = null
        console.log(err)
      })
  }
}

export default new OrderStore();
